import React from 'react';

export const helpContent = {
  '/dashboard': {
    title: 'Dashboard Overview',
    content: (
      <div className="space-y-6">
        <p className="text-gray-700">Welcome to the Silulumanzi enterprise management system dashboard.</p>
        
        <div>
          <h3 className="font-semibold text-lg mb-3 text-gray-800">Quick Navigation</h3>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li><strong>Procurement:</strong> Manage RFQs, specifications, and requisitions</li>
            <li><strong>Asset Management:</strong> Track hardware, software, and systems</li>
            <li><strong>Water Tanker:</strong> Monitor vehicle operations and transactions</li>
            <li><strong>IT Support:</strong> Access helpdesk and chat support</li>
            <li><strong>Reports:</strong> View analytics and system reports</li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold text-lg mb-3 text-gray-800">Getting Started</h3>
          <ol className="list-decimal list-inside space-y-2 text-gray-700">
            <li>Use the sidebar to navigate between different modules</li>
            <li>Check notifications for urgent items requiring attention</li>
            <li>Click the Help button for context-specific assistance</li>
            <li>Access your profile and settings from the top-right menu</li>
          </ol>
        </div>
      </div>
    )
  },

  '/dashboard/helpdesk': {
    title: 'Helpdesk System',
    content: (
      <div className="space-y-6">
        <p className="text-gray-700">The helpdesk system manages technical support tickets and user assistance requests across the entire Silulumanzi platform.</p>
        
        <div>
          <h3 className="font-semibold text-lg mb-3 text-gray-800">Ticket Management</h3>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li><strong>Create Tickets:</strong> Submit new support requests with detailed descriptions</li>
            <li><strong>Track Status:</strong> Monitor ticket progress from creation to resolution</li>
            <li><strong>Priority Levels:</strong> Set urgency levels (Low, Medium, High, Critical)</li>
            <li><strong>Categories:</strong> Organize tickets by system module or issue type</li>
            <li><strong>Assignments:</strong> Route tickets to appropriate support staff</li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold text-lg mb-3 text-gray-800">Support Features</h3>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li><strong>File Attachments:</strong> Upload screenshots, documents, or error logs</li>
            <li><strong>Comments & Updates:</strong> Add progress notes and communicate with users</li>
            <li><strong>Escalation:</strong> Route complex issues to specialized teams</li>
            <li><strong>Knowledge Base:</strong> Access common solutions and documentation</li>
            <li><strong>User Communication:</strong> Keep users informed of ticket status</li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold text-lg mb-3 text-gray-800">System Coverage</h3>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li><strong>Procurement System:</strong> RFQ, specifications, requisitions, suppliers</li>
            <li><strong>Asset Management:</strong> Hardware, software, systems tracking</li>
            <li><strong>Water Tanker Operations:</strong> Vehicle management, transactions</li>
            <li><strong>IT-IMS:</strong> Helpdesk, chat, calendar, notifications</li>
            <li><strong>Accounting & Reporting:</strong> Financial systems, analytics</li>
            <li><strong>User Management:</strong> Accounts, roles, permissions, masquerading</li>
          </ul>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <h4 className="font-semibold text-blue-800 mb-2">Quick Tips</h4>
          <ul className="list-disc list-inside space-y-1 text-blue-700 text-sm">
            <li>Provide detailed descriptions and steps to reproduce issues</li>
            <li>Include relevant screenshots or error messages</li>
            <li>Set appropriate priority levels to ensure timely response</li>
            <li>Check existing tickets before creating duplicates</li>
            <li>Use the knowledge base for common solutions</li>
          </ul>
        </div>
      </div>
    )
  },


  default: {
    title: 'General Help',
    content: (
      <div className="space-y-6">
        <p className="text-gray-700">Welcome to the Silulumanzi enterprise management system. This help system provides guidance for system-wide support and assistance.</p>
        
        <div>
          <h3 className="font-semibold text-lg mb-3 text-gray-800">Available Support</h3>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li><strong>Helpdesk:</strong> Submit technical support tickets for system issues</li>
            <li><strong>Live Chat:</strong> Get immediate assistance from support staff</li>
            <li><strong>Notifications:</strong> Check the bell icon for system updates and alerts</li>
            <li><strong>Profile Menu:</strong> Access your account settings and preferences</li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold text-lg mb-3 text-gray-800">System Modules</h3>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li><strong>Procurement:</strong> Manage RFQs, specifications, and requisitions</li>
            <li><strong>Asset Management:</strong> Track hardware, software, and systems</li>
            <li><strong>Water Tanker:</strong> Monitor vehicle operations and transactions</li>
            <li><strong>IT-IMS:</strong> Access helpdesk, chat, and calendar features</li>
            <li><strong>Reports:</strong> View analytics and system reports</li>
            <li><strong>Accounting:</strong> Financial management and reporting</li>
          </ul>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <h4 className="font-semibold text-blue-800 mb-2">Need Help?</h4>
          <p className="text-blue-700 text-sm">
            For technical issues or questions about any system module, use the <strong>Helpdesk</strong> 
            to submit a support ticket. The helpdesk covers all aspects of the Silulumanzi platform.
          </p>
        </div>
      </div>
    )
  }
};